export default __webpack_public_path__ + "static/media/androidstep.6110d576.PNG";